controller = require('./table_sort_controller')

angular.module('wbComponents').directive 'wbTableSort',
[  ->
  restrict: 'A'
  scope: {
    onSort: '=wbTableSort'
  }
  controllerAs: 'ctrl'
  bindToController: true
  controller: controller
]
